import { Component, Input, OnInit, Output } from '@angular/core';
import { CronometrotiempoService } from 'src/app/services/cronometro/cronometrotiempo.service';

@Component({
  selector: 'app-cronometrotiempo',
  templateUrl: './cronometrotiempo.component.html',
  styleUrls: ['./cronometrotiempo.component.css']
})
export class CronometrotiempoComponent implements OnInit {
  @Input() iniciaCronometraje : string;
  @Input() seccionsider : boolean;
  @Input() startcronometro : boolean;
  

  colorfondo= "#06f416";
  // set iniciaCronometraje(value: number) {
  //   value = value || 0 ;
  // }

 hours: number = 0;
 minutes: number = 0;
 seconds: number = 0;

private timer : any;
private date = new Date();

public show: boolean = true;
public disabled: boolean = false;
public animate: boolean=false;



  constructor(
    private cronometrotiempoService : CronometrotiempoService
  ) { }

  ngOnInit() {
     console.log ("-----------------",this.seccionsider);

     if (this.seccionsider) {
     let tiempoActual=JSON.parse(this.iniciaCronometraje);

     this.hours=tiempoActual.hor;
     this.minutes=tiempoActual.min;
     this.seconds=tiempoActual.seg;
     } else {

      this.hours=0;
     this.minutes=0;
     this.seconds=1;

     }

     
 if (this.startcronometro) {
this.start();
 }

 
   
    
    
   
  }


  increment(type: 'H' | 'M' | 'S') {
    if (type === 'H') {
      if (this.hours >= 99) return;
      this.hours += 1;
    }
    else if (type === 'M') {
      if (this.minutes >= 59) return;
      this.minutes += 1;
    }
    else {
      if (this.seconds >= 59) return;
      this.seconds += 1;
    }
  }
  
  decrement(type: 'H' | 'M' | 'S') {
    if (type === 'H') {
      if (this.hours <= 0) return;
      this.hours -= 1;
    }
    else if (type === 'M') {
      if (this.minutes <= 0) return;
      this.minutes -= 1;
    }
    else {
      if (this.seconds <= 0) return;
      this.seconds -= 1;
    }
  }



  updateTimer() {
    this.date.setHours(this.hours);
    this.date.setMinutes(this.minutes);
    this.date.setSeconds(this.seconds);
    this.date.setMilliseconds(0);
    const time = this.date.getTime();
    this.date.setTime(time + 1000);  //---

    this.hours = this.date.getHours();
    this.minutes = this.date.getMinutes();
    this.seconds = this.date.getSeconds();

    if (this.date.getHours() === 0 &&
      this.date.getMinutes() === 0 &&
      this.date.getSeconds() === 0) {
      //stop interval
      clearInterval(this.timer);
     // this.idAudio.nativeElement.play();
     // this.animate = true;
      setTimeout(() => {
    //    this.stop();
    //    this.idAudio.nativeElement.load();
      }, 5000);




    }


    let cronometrosidebar = {
      hor:this.hours,
      min:this.minutes,
      seg:this.seconds
    }

    if (this.seccionsider) {
      localStorage.setItem("cronometrosider", JSON.stringify(cronometrosidebar) ); 
    } 
    
  }



  



  start() {
    if (this.hours > 0 || this.minutes > 0 || this.seconds > 0) {

      this.disabled = true;
      this.show = false;  //hide btn + and -
      this.updateTimer();

      if(this.seconds > 0){
        this.timer = setInterval(() => {
          this.updateTimer();
        }, 1000);
      }


     

    }
  }

  stop() {    
    this.disabled = false;
    this.show = true;
    this.animate = false;
    clearInterval(this.timer);
  //  this.idAudio.nativeElement.load();
  }

  reset() {
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
    this.stop();
  }


}
